import { useEffect } from "react";
import { createRoot } from "react-dom/client";

export const useIFrameProcessorEffect = ({ container, content }) => {
  useEffect(() => {
    if (!container) return;

    const embedNodes = container.querySelectorAll("oembed[url]");

    // Spread NodeList to allow forEach for all browsers
    [...embedNodes].forEach(element => {
      const root = createRoot(element);

      root.render(<iframe src={element.attributes.url.value} />);
    });
  }, [content, container]);
};
